// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Loan\\'s payment intervals'" tab="true">
    <a command-access="CreatePaymentIntervalDefinition" class="sub-header__create-button btn btn-primary" ng-href="#!/admin/loan-products/interval/create">
      Create new
    </a>
  </sub-header>
  <div>
    <table class="table table--generate-row-ids"
           at-table
           at-list="\$ctrl.paymentIntervals">
      <thead></thead>
      <tbody class="tbody">
        <tr class="products-table__row">
          <td/>
            <td at-implicit at-attribute="name" at-title="Name"></td>
            <td class="table__actions">
              <button command-access="DisablePaymentIntervalDefinition" type="button" class="products-table__item-edit btn btn-danger" ng-click="\$ctrl.remove(item)">
                Remove
              </button>
              <a command-access="EditPaymentIntervalDefinition" class="products-table__item-edit btn btn-warning" ng-href="#!/admin/loan-products/interval/edit/{{item.id}}">
                Edit
              </a>
            </td>
        </tr>
      </tbody>
    </table>
    <div ng-if="!\$ctrl.paymentIntervals || !\$ctrl.paymentIntervals.length"
         class="empty-message">
      <span>No payment intervals.</span>
    </div>
  </div>

  <div class="buttons">
    <button class="btn btn-warning" ng-click="\$ctrl.goBack()">Back</button>
  </div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/loan/intervals/payment-interval-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;